<template>
    <div class="text-center pa-3">
        <v-img src="@/assets/img/helpical-colorful.png" width="50" height="50" :aspect-ratio="1" class="mb-3 mx-auto mt-3"></v-img>
        <p class="font-weight-bold text-grey-darken-2 text-meta mb-1">لایسنس {{ $system.license.product }}</p>
        <p class="text-small text-grey mb-3">{{ $system.license.type == 'selfhost' ? 'نسخه محلی' : 'نسخه ابری' }}</p>
        <hr class="mx-5 text-grey-lighten-4">
        <p v-for="(value, key) in items" class="text-grey-darken-1 text-small mt-1">{{ key }}: {{ value }}</p>
        <a href="https://panel.helpical.ir" target="_blank" class="text-decoration-none"><v-btn color="secondary" class="px-6 mt-4">مدیریت لایسنس</v-btn></a>
    </div>
</template>
<script>
export default {
    data() {
        return {
            items:{
                'تعداد کاربران سازمانی': this.$system.license.defined_employees + ' / ' + this.$system.license.employees_count,
                'تاریخ انقضا لایسنس': this.$moment(this.$system.license.expired_at, 'YYYY/MM/DD').format('jYYYY/jMM/jDD'),
            }
        };
    },
};
</script>
